import React from 'react';
import { Member, useAppSettings } from '@springbig/shared';
import { Center, HStack, Skeleton, VStack } from 'native-base';
import SliderBar, { DefaultValuesPointsProps } from '~/shared/RangeBar';
import { Caption } from '~/shared/Typography';

import { Panel, Button } from '~/shared/Theme';

type RewardHeaderProps = {
    member?: Member | null;
    setShowLoyaltyAlert: (show: boolean) => void;
    rewardMaxAmount?: number
    rewardCheckPoints: DefaultValuesPointsProps[]
};

const RewardHeader = ({
    member,
    rewardCheckPoints,
    rewardMaxAmount,
    setShowLoyaltyAlert
}: RewardHeaderProps) => {

    const {
        style: { rewards: { rewardHeader = {}, rewardpoints = {} } = {} } = {}
    } = useAppSettings();

    return (
        <Panel {...rewardHeader} pb={8}>
            <Center alignItems='center' >
                <Caption
                    fontSize={'3xl'}
                    {...rewardpoints}
                >
                    { member?.balance || '0' }
                </Caption>
                <Caption
                    fontSize={'xl'}
                    text={'rewards.available_points'}
                />
                { member && !member.allowed_loyalty &&
                    <Button
                        variant={'text'}
                        text={'rewards.click_here_to_earn'}
                        onPress={() => setShowLoyaltyAlert(true)}
                    />
                }
                <Center w={'100%'} alignItems='center'>
                    { member &&
                        <SliderBar
                            maxValue={rewardMaxAmount}
                            valuePoints={rewardCheckPoints}
                            defaultValue={member.balance}
                            dots={true}
                        />
                    }
                </Center>
            </Center>
        </Panel>
    );

};

export const RewardHeaderSkeleton = () => {
    return (
        <VStack w='100%' alignSelf={'center'} alignItems={'center'} mt={10}>
            <Skeleton  w={20} h={30} mb={4} borderRadius={4} />
            <Skeleton  w={'15rem'} h={4} mb={4} borderRadius={4} />
            <HStack alignItems={'center'} alignSelf={'center'} w='60%' >
                <Skeleton  h={3} w={3} rounded={'full'}  borderRadius={5}/>
                <Skeleton  h={1.5}  />
                <Skeleton  h={3} w={3} rounded={'full'}  borderRadius={5}/>
            </HStack>
        </VStack>
    );
};

export default RewardHeader;
